import { useState, useEffect } from 'react'
import { Navigation } from './navigation'
import { newmenu } from './menu'
import { Header } from './header'
import { Features } from './features'
import { About } from './about'
import { Services } from './services'
import { Gallery } from './gallery'
import { Testimonials } from './testimonials'
import { Team } from './Team'
import { Contact } from './contact'
import JsonData from '../data/data.json'
import SmoothScroll from 'smooth-scroll'
import { NavLink, Route, Router, Routes } from 'react-router-dom';
import { render } from '@testing-library/react'



export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
})

const Home = () => {
  const [landingPageData, setLandingPageData] = useState({})
  useEffect(() => {
    setLandingPageData(JsonData)
  }, [])

  return (
    <div>
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      {/* <Services data={landingPageData.Services} /> */}
      {/* <Gallery /> */}
      {/* <Testimonials data={landingPageData.Testimonials} /> */}
      {/* <Team data={landingPageData.Team} /> */}
      <Contact data={landingPageData.Contact} />
    </div>
  )
}

export default Home

